import { ISupportedLanguageMap } from './index'

export const SUPPORTED_LANGUAGES: ISupportedLanguageMap = {
    abap: { displayName: "ABAP (Advanced Business Application Programming)" },
    apex: { displayName: "Apex" },
    bat: { displayName: "Batch" },
    clojure: { displayName: "Clojure" },
    coffee: { displayName: "CoffeeScript" },
    cpp: { displayName: "C++" },
    csharp: { displayName: "C#" },
    csp: { displayName: "CSP (Communication Sequential Processing)" },
    css: { displayName: "CSS" },
    dart: { displayName: "Dart" },
    dockerfile: { displayName: "Dockerfile" },
    fsharp: { displayName: "F#" },
    go: { displayName: "Go (Golang)" },
    graphql: { displayName: "Graphql" },
    handlebars: { displayName: "Handlebars" },
    html: { displayName: "HTML" },
    java: { displayName: "Java" },
    javascript: { displayName: "JavaScript" },
    julia: { displayName: "Julia" },
    kotlin: { displayName: "Kotlin" },
    less: { displayName: "Less" },
    lexon: { displayName: "Lexon" },
    lua: { displayName: "Lua" },
    markdown: { displayName: "Markdown" },
    mips: { displayName: "MIPS" },
    mysql: { displayName: "MySQL" },
    "objective-c": { displayName: "Objective-C" },
    pascal: { displayName: "Pascal" },
    perl: { displayName: "Perl" },
    pgsql: { displayName: "PGSQL" },
    php: { displayName: "PHP" },
    "": { displayName: "Plain Text" },
    powershell: { displayName: "PowerShell" },
    pug: { displayName: "pug" },
    python: { displayName: "Python3" },
    r: { displayName: "R" },
    ruby: { displayName: "Ruby" },
    rust: { displayName: "Rust" },
    scss: { displayName: "SCSS" },
    shell: { displayName: "Shell" },
    sophia: { displayName: "Sopia" },
    sql: { displayName: "SQL" },
    swift: { displayName: "Swift" },
    twig: { displayName: "Twig" },
    typescript: { displayName: "TypeScript" },
    vb: { displayName: "Visual Basic" },
    xml: { displayName: "XML" },
    yaml: { displayName: "YAML" }
}
